import React from 'react';
import AllDependentsDashboardComponent from './AllDependentsDashboardComponent';
import Loading from './LoadingComponent';
import DependentCard from './DependentCard';

const AllDependentsPopUp = ({ 
    isOpen, 
    onClose, 
    dependentList, 
    onNavigate, 
    onAddDependent, 
    isQuotaFull, 
    loading,
    detailsRoute,
    selectedDependentId,
    shouldDisable
}) => {
    if (!isOpen) return null;

    return (
        <div className="depDash__nav-dropdown-overlay" onClick={onClose}>
            <div className="depDash__nav-dropdown-container" onClick={(e) => e.stopPropagation()}>
                <div className="depDash__nav-dropdown-header">
                    <svg 
                        className='cursorPointer closePopUpIcon' 
                        width="24" 
                        height="24" 
                        onClick={onClose} 
                        viewBox="0 0 17 17" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M8.5 6.61572L15.1114 0L17 1.88461L10.3886 8.5L17 15.1154L15.1114 17L8.5 10.3843L1.88859 17L0 15.1154L6.61141 8.5L0 1.88461L1.88859 0L8.5 6.61572Z" fill="#71767A"/>
                        </svg>
                </div>

                <div className="depDash__nav-dropdown-content">
                    {loading ? (
                        <div style={{ height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Loading />
                        </div>
                    ) : (
                        <div className="depDash__grid" style={{ padding: '0 20px',marginTop:'20px' }}>
                            {(dependentList || [])
                                .map(item => item.obj || item)
                                .filter(dep => (dep?.status ?? 1) === 0)
                                .map((dep, i) => (
                                    <DependentCard
                                        key={dep?.id || i}
                                        dependent={dep}
                                        onNavigate={onNavigate}
                                        onAddDependent={onAddDependent}
                                        isQuotaFull={isQuotaFull}
                                        detailsRoute={detailsRoute}
                                        selectedDependentId={selectedDependentId}
                                        shouldDisable={shouldDisable}
                                    />
                                ))
                            }
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AllDependentsPopUp;
